<template>
	<div class="md:grid md:grid-cols-3 md:gap-2">
		<div class="mb-2 p-[2px] rounded-lg" v-for="nextOffCards in 9" :key="`next-off-loader-card-${nextOffCards}`">
			<div class="p-[2px] px-[6px] rounded-t-lg bg-dark-800 dark:bg-dark-700 leading-none">
				<div class="flex items-center">
					<UiSkeleton class="h-[20px] w-[20px] rounded-full bg-light-500 dark:bg-dark-500" />
					<UiSkeleton class="h-[16px] w-[50px] ml-1 bg-light-500 dark:bg-dark-500" />
				</div>
				<UiSkeleton class="h-[18px] w-[80px] rounded-xl m-1 bg-light-500 dark:bg-dark-500" />
			</div>

			<div
				v-for="outcome in 3"
				:key="`outcome-skeleton-loader-${outcome}`"
				class="bg-light-50 dark:bg-dark-800 base-text border border-[transparent] border-b-light-300 dark:border-b-dark-700 py-[2px] h-9 p-1 flex items-center justify-between"
			>
				<div class="flex items-center">
					<UiSkeleton class="h-[14px] w-[20px] mx-1 bg-light-500 dark:bg-dark-500" />
					<UiSkeleton class="h-[30px] w-[30px] mx-1 bg-light-500 dark:bg-dark-500" />
					<UiSkeleton class="h-[25px] w-[80px] mx-2 bg-light-500 dark:bg-dark-500" />
				</div>
				<UiSkeleton class="h-[30px] w-[50px] bg-light-500 dark:bg-dark-500" />
			</div>
			<div class="h-10 bg-light-50 dark:bg-dark-700 rounded-b-lg flex items-center">
				<UiSkeleton class="h-[30px] w-full bg-light-500 dark:bg-dark-500 m-1" />
			</div>
		</div>
	</div>
</template>
